/**
 * contrastText is navy, not white, on every accent colour.
 *
 * White was declared by hand on success, info, error and warning, and it fails AA
 * badly on all of them — success #13DEB9 reaches only 1.72:1 and warning #FFAE1F
 * 1.85:1, against a 4.5:1 floor. Navy #040433 is a brand colour and clears every
 * one of them (7.01:1 to 11.38:1). See docs/design-system.md.
 *
 * primary has no contrastText on purpose: MUI derives a dark label for #FF7235 by
 * itself (7.71:1). Declaring white here would break it.
 */
const baselightTheme = {
  direction: 'ltr',
  palette: {
    primary: {
      main: '#FF7235',
      light: '#FFF1EB',
      dark: '#E5622A',
    },
    secondary: {
      main: '#5D3CBF',
      light: '#EEE8FF',
      dark: '#4B2EA2',
    },
    success: {
      main: '#13DEB9',
      light: '#E6FFFA',
      dark: '#02b3a9',
      contrastText: '#040433',
    },
    info: {
      main: '#539BFF',
      light: '#EBF3FE',
      dark: '#1682d4',
      contrastText: '#040433',
    },
    error: {
      main: '#FA896B',
      light: '#FDEDE8',
      dark: '#f3704d',
      contrastText: '#040433',
    },
    warning: {
      main: '#FFAE1F',
      light: '#FEF5E5',
      dark: '#ae8e59',
      contrastText: '#040433',
    },
    purple: {
      A50: '#EBF3FE',
      A100: '#6610f2',
      A200: '#557fb9',
    },
    grey: {
      100: '#F2F6FA',
      200: '#EAEFF4',
      300: '#DFE5EF',
      400: '#7C8FAC',
      500: '#5A6A85',
      600: '#2A3547',

    },
    text: {
      primary: '#040433',
      secondary: '#1C1C4A',
    },
    action: {
      disabledBackground: 'rgba(73,82,88,0.12)',
      hoverOpacity: 0.02,
      hover: '#f6f9fc',
    },
    divider: '#e5eaef',
    chat: {
      userMessage: {
        background: '#f2f6fa',
        text: '#2A3547',
      },
      botMessage: {
        background: '#E8BCFF',
        text: '#2A3547',
      },
      humanMessage: {
        background: '#DCF7C5',
        text: '#2A3547',
      },
    },
  },
};

const baseDarkTheme = {
  direction: 'ltr',
  palette: {
    primary: {
      main: '#FF9B6E',
      light: '#4a3024',
      dark: '#E57A48',
      contrastText: '#0c1318',
    },
    secondary: {
      main: '#9B7AFF',
      light: '#3d2f6b',
      dark: '#7B5AE8',
      contrastText: '#040433',
    },
    success: {
      main: '#13DEB9',
      light: '#1B3C48',
      dark: '#02b3a9',
      contrastText: '#040433',
    },
    info: {
      main: '#539BFF',
      light: '#223662',
      dark: '#1682d4',
      contrastText: '#040433',
    },
    error: {
      main: '#FA896B',
      light: '#4B313D',
      dark: '#f3704d',
      contrastText: '#040433',
    },
    warning: {
      main: '#FFAE1F',
      light: '#4D3A2A',
      dark: '#ae8e59',
      contrastText: '#040433',
    },
    purple: {
      A50: '#EBF3FE',
      A100: '#6610f2',
      A200: '#557fb9',
    },
    grey: {
      100: '#182229',
      200: '#2a3942',
      300: '#3d4f5c',
      400: '#8696a0',
      500: '#aebac1',
      600: '#e9edef',
    },
    text: {
      primary: '#e9edef',
      secondary: '#8696a0',
    },
    action: {
      disabledBackground: 'rgba(255,255,255,0.08)',
      hoverOpacity: 0.06,
      hover: '#2a3942',
    },
    divider: '#2a3942',
    background: {
      default: '#111b21',
      dark: '#111b21',
      paper: '#202c33',
    },
    chat: {
      userMessage: {
        background: '#005c4b',
        text: '#e9edef',
      },
      botMessage: {
        background: '#202c33',
        text: '#e9edef',
      },
      humanMessage: {
        background: '#1e3933',
        text: '#e9edef',
      },
    },
  },
};

export { baseDarkTheme, baselightTheme };
